import { Dashboard, TeamBuilder, TimeLine } from 'src/Pages';

export interface IPrivateRoutes {
  path: string;
  title: string;
  element: any;
}

export const PrivateRoutes: IPrivateRoutes[] = [
  {
    path: '/',
    title: 'Dashboard',
    element: <Dashboard />,
  },
  {
    path: '/team-builder',
    title: 'Team Builder',
    element: <TeamBuilder />,
  },
  {
    path: '/timeline',
    title: 'Timeline',
    element: <TimeLine />,
  },
  {
    path: '/members',
    title: 'Members',
    element: (
      <div>
        <h1>Main</h1>
      </div>
    ),
  },
  {
    path: '/projects',
    title: 'Projects',
    element: (
      <div>
        <h1>Main</h1>
      </div>
    ),
  },
  {
    path: '/get-feedback',
    title: 'Get Feedback',
    element: (
      <div>
        <h1>Main</h1>
      </div>
    ),
  },
  {
    path: '/get-updates',
    title: 'Get Updates',
    element: (
      <div>
        <h1>Main</h1>
      </div>
    ),
  },
  {
    path: '/reports',
    title: 'Reports',
    element: (
      <div>
        <h1>Main</h1>
      </div>
    ),
  },
  {
    path: '/attendance',
    title: 'Attendance',
    element: (
      <div>
        <h1>Main</h1>
      </div>
    ),
  },
  {
    path: '/settings',
    title: 'Settings',
    element: (
      <div>
        <h1>Main</h1>
      </div>
    ),
  },
];
